import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export type IAddAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class AddAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IAddAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'addAnalyticsExtensionsConnection', params);
  }
}
